module.exports = __webpack_public_path__ + "static/media/blog_grid_1.4179e574.jpg";